export const initLoadMoreButton = ({
  pageFieldSelector,
  onBeforeSend,
  onSuccess,
  onFail,
  onAlways
} = {}) => {
  const $body = $('body');
  const handlerFlag = 'loadMoreHandlerBound';
  const pageStateKey = 'loadMoreCurrentPage';

  if ($body.data(handlerFlag)) {
    return;
  }
  $body.data(handlerFlag, true);

  const $pageInput = pageFieldSelector ? $(pageFieldSelector) : null;
  const initialPageValue = $pageInput ? parseInt($pageInput.val(), 10) : null;
  const initialPage = Number.isInteger(initialPageValue) ? initialPageValue : 1;
  $body.data(pageStateKey, initialPage);

  const getCurrentPage = () => {
    const value = parseInt($body.data(pageStateKey), 10);
    return Number.isInteger(value) ? value : 1;
  };

  const setCurrentPage = (pageNumber) => {
    $body.data(pageStateKey, pageNumber);
  };

  $body.on('click', '#next_link', function(event) {
    event.preventDefault();
    const $button = $(this);
    const nextUrl = $button.data('nextUrl');
    const buttonNextPage = parseInt($button.data('nextPage'), 10);

    if (!nextUrl || $button.prop('disabled') || $button.data('loading')) {
      return;
    }

    const previousPageValue = $pageInput ? $pageInput.val() : null;
    const previousCurrentPage = getCurrentPage();
    const urlInstance = new URL(nextUrl, window.location.origin);
    const urlPage = parseInt(urlInstance.searchParams.get('page'), 10);
    const requestedPage = Number.isInteger(buttonNextPage)
      ? buttonNextPage
      : (Number.isInteger(urlPage) ? urlPage : previousCurrentPage + 1);
    urlInstance.searchParams.set('page', requestedPage);
    const finalUrl = urlInstance.toString();

    if ($pageInput) {
      $pageInput.val(requestedPage);
    }

    if (typeof onBeforeSend === 'function') {
      onBeforeSend($button);
    }

    $button.data('loading', true);

    $.ajax({
      url: finalUrl,
      method: 'GET',
      dataType: 'script'
    }).done(() => {
      setCurrentPage(requestedPage);
      if ($pageInput) {
        $pageInput.val('');
      }
      if (typeof onSuccess === 'function') {
        onSuccess($button);
      }
    }).fail(() => {
      if ($pageInput) {
        $pageInput.val(previousPageValue);
      }
      setCurrentPage(previousCurrentPage);
      if (typeof onFail === 'function') {
        onFail($button);
      }
    }).always(() => {
      $button.removeData('loading');
      if (typeof onAlways === 'function') {
        onAlways($button);
      }
    });
  });
};
